import { gql } from "graphql-request"


export const algorand = {
    name: 'algorand',
    title: 'Algorand',
    currency: 'ALGO',
    check: true,
    regexp: '([\\W]|^)([0-9A-Z]{58})([\\W]|$)',
    noregxp: [
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],

    query: gql`query ($address: String!) {
        algorand(network:algorand) {
            address(address: {is: $address}) {
                balance
                balance_usd: balance(in: USD)
            }
            ins: transfers(receiver: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyIn: transfers(receiver: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
            outs: transfers(sender: {is: $address}) {
                count
                min_date: minimum(of: date)
                max_date: maximum(of: date)
            }
            currencyOut: transfers(sender: {is: $address}) {
                count
                currency {
                    symbol
                    address
                    tokenId
                }
            }
        }
    }`,
    checkAddress: 'OVAA75Q4VPN7JLKD6GEKBRV6WEEZSQTN5H6RVR2XM4JMR3WXSABY4VAT6E',
}
